import { QuadtreeItem } from 'quadtree-lib';

import { paths } from '../../config/paths.config';
import Element from './element';
import Animation, { AnimationParams } from './animation';
import Projectile, { ProjectileParams } from './projectile';
import Ship from './ship/ship';

export interface MissileParams extends ProjectileParams {
  explosionRadius?: number;
}

export default class Missile extends Projectile implements MissileParams {
  explosionRadius: number = 0;

  constructor(params: MissileParams) {
    super(params);
    this.applyParams(params);
  }

  getTargetsInExplosionRadius(): Array<Element> {
    const { x, y, explosionRadius } = this;
    const quadtree = this.getTargetsQuadtree();
    if (!quadtree)
      return [];
    return quadtree
      .colliding(
        {
          x: x - explosionRadius / 2,
          y: y - explosionRadius / 2,
          width: explosionRadius,
          height: explosionRadius,
        }
      )
      .map((e: QuadtreeItem) => this.getScene().elements[e.id])
      ;
  }

  handleCollision(): void {
    const targetInCollision = this.getTargetsInCollision()[0];
    if (targetInCollision) {
      /* explosion animation */
      new Animation({
        scene: this.scene,
        context: this.context,
        x: this.x,
        y: this.y,
        width: this.explosionRadius * 2,
        height: this.explosionRadius * 2,
        lookAngle: this.lookAngle,
        spriteParams: {
          src: `${paths.img.animations}/boom3.png`,
          spriteWidth: 780,
          spriteHeight: 910,
          numberOfFramesBeforeNextStep: 3,
          frameCount: 6,
          stageCount: 7,
        }
      } as AnimationParams).create();

      this.getTargetsInExplosionRadius()
        .forEach(el => {
          const ship = el as Ship;
          if (ship.takeDamages)
            ship.takeDamages(this.damage);
        })
        ;
      this.remove();
    }
  }
}
